import { SummaryField } from './summaryApi';

/** Группа шапки таблицы: название и число колонок под ней */
export interface SummaryGroup {
  name: string;
  span: number;
}

/** Колонки без группы в table_info не пропадают, а попадают в общую группу */
export const FALLBACK_GROUP = 'Прочее';

/**
 * Группы верхнего уровня шапки по колонкам (без даты). Соседние колонки с одинаковой группой сливаются,
 * порядок колонок не меняется - он совпадает с порядком выгрузки в Excel.
 */
export function groupSummaryColumns(columns: SummaryField[]): SummaryGroup[] {
  const groups: SummaryGroup[] = [];
  columns.forEach((field) => {
    const name = field.group || FALLBACK_GROUP;
    const last = groups.length ? groups[groups.length - 1] : null;
    if (last && last.name === name) {
      last.span += 1;
    } else {
      groups.push({ name, span: 1 });
    }
  });
  return groups;
}
